<app-custom-modal customTitle="Enviar a firmar a tablet" [hideFooter]="true" (closeFunction)="closeFormFunction()">

    @if(loading){
    <div class="flex flex-col items-center justify-center py-8 text-gray-400">
        <p class="text-sm">Buscando tablets conectadas…</p>
    </div>
    } @else if(tablets.length === 0){
    <div class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-100 rounded-lg">
        <p class="text-gray-400 italic text-sm">No hay tablets conectadas en la oficina de este documento.</p>
    </div>
    } @else {
    <div class="space-y-2">
        @for (tablet of tablets; track tablet.id) {
        <button type="button" (click)="sendTo(tablet)" [disabled]="sendingId !== null"
            class="w-full flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-300 hover:bg-indigo-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-left">
            <span class="flex items-center gap-2">
                <span class="h-1.5 w-1.5 rounded-full bg-green-500"></span>
                <span class="text-sm font-semibold text-gray-800">{{ tablet.name }}</span>
            </span>
            <span class="text-xs text-indigo-500 font-medium">
                {{ sendingId === tablet.id ? 'Enviando…' : 'Enviar' }}
            </span>
        </button>
        }
    </div>
    }

</app-custom-modal>
